import { Button, Flex, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Image from "components/Image";
import iconError from "assets/images/error-triangle.svg";
import { useAppDispatch, useTypedSelector } from "redux/hooks";
import { useLogoutMutation } from "redux/services/auth";
import { logout, selectAuth } from "redux/slices/authSlice";
import env from "env";
import GuestLayout from "layouts/GuestLayout";

const NoBusinessUnit = () => {
  const [redirectTime, setRedirectTime] = useState(5);

  const dispatch = useAppDispatch();
  const { accessToken } = useTypedSelector(selectAuth);
  const [logoutServer] = useLogoutMutation();

  const onLogout = () => {
    dispatch(logout());
    logoutServer(accessToken as string);
    window.location.href = `${env.api.baseUrl.tokenBaseUrl}oidc/logout?client_id=${env.app.authCodeAppId}&post_logout_redirect_uri=${env.app.rootUrl}`;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setRedirectTime((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GuestLayout>
      <Flex
        minH="100vh"
        backgroundColor="#fbfbfb"
        justifyContent={["left", "left", "center"]}
        alignItems="center"
        flexDir="column"
        gap="30px"
        position="relative"
        pt={["100px", "100px", "0"]}
      >
        <Image
          data-testid="no-business-unit-image"
          w="364px"
          src={iconError}
          alt="Error"
          loading="lazy"
        />

        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          gap="10px"
        >
          <Text
            data-testid="no-business-unit-text"
            textAlign="center" color="red" textStyle="h2"
          >
            No business unit has been assigned to your organization yet
          </Text>

          <Text
            data-testid="redirect-timer"
            fontSize="12px"
            fontWeight="500"
            color="var(--chakra-colors-gray-500)"
          >
            Redirect to login page in{" "}
            <Text
              as="span"
              fontWeight="500"
              color="var(--chakra-colors-blue-500)"
            >
              {redirectTime}
            </Text>
            {" "}second{`${redirectTime > 1 ? "s" : ""}`}
          </Text>
          <Button
            data-testid="logout-button"
            colorScheme="blue"
            minWidth="80px"
            onClick={onLogout}
            mt="10px"
          >
            Sign out now
          </Button>
        </Flex>
      </Flex>
    </GuestLayout>
  );
};

export default NoBusinessUnit;
